import React, { memo } from "react";
import styled from "styled-components";
import { GolFieldElement } from "./gol-contact-form-interfaces";
import { TextField } from "@material-ui/core";

const CustomErrorField = styled(TextField)`
  &.error {
    fieldset {
      border-color: ${(props) => props.theme.error};
    }

    p.Mui-required {
      color: ${(props) => props.theme.error};
      margin-top: 0;
    }
  }
`;

const GolContactErrorField = memo((props: GolFieldElement) => {
  const {
    clazz,
    onChange,
    errorMsg,
    required = false,
    value,
    label,
    name,
    textSize = "small",
  } = props;
  return (
    <CustomErrorField
      fullWidth={false}
      size={textSize}
      name={name}
      onChange={onChange}
      className={clazz}
      required={required}
      label={label}
      variant={"outlined" as any}
      helperText={errorMsg}
      defaultValue={value}
    />
  );
});

export { GolContactErrorField };
